import script from "./GameGuild.vue?vue&type=script&setup=true&lang=js"
export * from "./GameGuild.vue?vue&type=script&setup=true&lang=js"

import "./GameGuild.vue?vue&type=style&index=0&id=8fb2188e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fb2188e"]])

export default __exports__